module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/general/gzz-main-content/gzz-main-content.component.html
// module id = ../../../../../src/app/components/general/gzz-main-content/gzz-main-content.component.html
// module chunks = main